import ClientPortal from '../../plugins/axios'
import UserCookie from 'vue-cookies'

export default async function checkEligibleAPE ( { next } ) {
    // await ClientPortal.get(`${process.env.VUE_APP_API}/signup/getCsrfToken`).then((res) => {
    //     ClientPortal.defaults.headers.common['X-CSRF-TOKEN'] = res.data.csrfToken
    // })
    await ClientPortal.post(`${process.env.VUE_APP_API}/login/consultation/eligibleAPE`,
        {
            MEMBN: UserCookie.get('usermembn')
        },
        { withCredentials : true }
    ).then((response) => {
        if(response.status == 200 && response.data.eligible == true) {
            return next()
        } else {
            return next('/dashboard/annual-physical-exam/main/')
        }
    }).catch(() => {
        return ('/')
        // console.log("Error: ", error);
    })
}
